export default __webpack_public_path__ + "static/media/virus.8a63ba7b.svg";